






















































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import ProductAssociation from './productAssociationDialog.vue';
import SelectDataCenter from './todoComponents/selectDataCenterDialog.vue';
import PhysicalAddress from './todoComponents/physicalAddressDialog.vue';
import Scrutinizer from './todoComponents/scrutinizerDialog.vue';
import ManageEmailSecurity from './todoComponents/manageEmailSecurity.vue';
import SysLogAnaltyics from './todoComponents/sysLogAnaltyicsDialog.vue';
import NsvSerialProductPlatform from './todoComponents/nsvSerialProductPlatform.vue';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
// import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';
import { TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { tooltip, TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import MxRecordDialog from './mx-record-dialog.vue';
import UpdateHesPasswordDialog from './updateHESPassword.vue';
// import jsEncrypt from '@/shared/jsEncrypt';
import OnPremDialog from './todoComponents/onPremDialog.vue';
import UpdateWcmDialog from './updateWCMDialog.vue';
import ManageSharedLicense from './manageSharedLicenseDialog.vue';
import CloudTenantList from './todoComponents/cloudTenantList.vue';
import ManageGuidDialog from './manage-guid-dialog.vue';
import ZtServerConfig from './todoComponents/ztServerConfig.vue';
import ClosedNetworkDialog from './closed-network-dialog.vue';
import MsspMonthlyManagedDialog from './conifrmMSSPMonthlyManagedDialog.vue';
import { ConfirmButton, ConfirmOptions, confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import ApiServiceWrapper from '@/shared/api-request.service';
import { envCongif } from '@/shared/env.config';
import { currentUserKey } from '@/shared/msw-constants';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwExpandableTextfield , SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { countryCodes } from '@/shared/country-selector/countryCodes';
import SESModal from './todoComponents/sesModal.vue';
// import ApiServiceWrapper from '@/shared/api-request.service';

const cssPrefix = 'productDetail_Tab3';
@Component({
  components: {
    ...UUIFComponent,
    ProductAssociation,
    SelectDataCenter,
    OnPremDialog,
    PhysicalAddress,
    Scrutinizer,
    ManageEmailSecurity,
    SysLogAnaltyics,
    NsvSerialProductPlatform,
    MxRecordDialog,
    UpdateHesPasswordDialog,
    UpdateWcmDialog,
    ManageSharedLicense,
    CloudTenantList,
    ZtServerConfig,
    ManageGuidDialog,
    ClosedNetworkDialog,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwExpandableTextfield,
    SwTextfield,
    SwSelect,
    SwToggle,
    MsspMonthlyManagedDialog,
    SESModal,
  }, directives: {
    tooltip,
  },
})
export default class MswProductDetailTab3 extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedProductType)
  selectedProductType: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @Prop()
  todoList: any;
  @Prop()
  isTz: boolean;
  @Prop()
  todayDate: string;
  todaysDate: string = '';
  friendlyNameEditText: string = '';
  friendlyNameEditFlag: boolean = false;
  productGroupEditText: string = '';
  productGroupEditFlag: boolean = false;
  ttfqdnListEditFlag : boolean = false;
  showAssociationProduct: boolean = false;
  showOnPremDialog : boolean = false;
  isSSEProduct : boolean = false;
  onpremdetails : any;
  associatedTask: any = {};
  productGroupList: any = [];
  fwManagementOption : any = [];
  switchManagementOption : any = [];
  fwManageValue : string = '';
  switchManageValue : string = '';
  showDataCenterDialog: boolean = false;
  showDCFirewall :boolean = false;
  showTenantChangeDC :boolean = false;
  showSysLogAnaltyicsDialog: boolean = false;
  dcOptions: any = [];
  selectedTodo: any = {};
  showPhysicalAddressDialog: boolean = false;
  showScrutinizerDialog: boolean = false;
  showEmailSecurityDialog: boolean = false;
  scrutinizerHelpText: string = '';
  emailSecurityDetail: any;
  ttServerList : SelectOption[] = [];
  ttServerText : string = '';
  showTtServerTextField : boolean = false;
  ttServerEditedText : string = '';
  ztToggle : boolean = false;
  showNSVRegistration: boolean = false;
  assochint: string = '';
  showMXRecordDialog = false;
  domainName: any;
  mxRecords: any;
  fwManageEditFlag : boolean = false;
  switchMangeEditFlag : boolean = false;
  showUpdateHesPasswordDialog: boolean = false;
  disableFwManagement : boolean = false;
  showFirewallMangement : boolean = false;
  showEditOptionPencil : boolean = false;
  showUpdateWCMDialog: boolean = false;
  showLicenseSharingDialog: boolean = false;
  lsgServiceId: string = '';
  showCloudTenantList : boolean = false;
  showZtServerConfig : boolean = false;
  cloudTenantList :any[] = [];
  showManageGuidDialog : boolean = false;
  modalValues: any = {};
  ztServerObj : any = {};
  closedNetworkValue: boolean = false;
  showClosedNetwork: boolean = false;
  showNsvToggle:boolean = false;
  showNsvToggleValue: boolean = false;
  options: ConfirmOptions;
  reveal: boolean = false;
  // tslint:disable-next-line
  tempURL = 'https://mswtest.nsmbluegreendev.com/APILambdaVerifyEmail/testredirectpage?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOiIxNjE5MDc4Nzg0IiwiaXNzIjoiaHR0cHM6Ly9teS5teXNvbmljd2FsbC5jb20vT0F1dGgyMCIsImF1ZCI6Imh0dHBzOi8vd3d3Lm15c29uaWN3YWxsLmNvbS9PQXV0aDIiLCJ1c2VyTmFtZSI6IjRfMjgzOTI3MzUiLCJjbGllbnRJZCI6Ik1VSVIxWEhJUzI3Iiwic0lkIjoiNjM4RERDNjUtMTY5Qi00NDAwLTlFQzAtRDAyMUI5M0YyMTBFIiwibG9jYWxlTmFtZSI6IkVOIiwiZ2l2ZW5OYW1lIjoiU3dhcG5pbCBLYXJtYWxrYXIiLCJlbWFpbCI6InNrYXJtYWxrYXJAc29uaWN3YWxsLmNvbSIsInNlbGYiOiIxIiwidmlld21vZGUiOiJzZWxmbXN3IiwiY29tcGFueU5hbWUiOiJTV0FQTklMIEtBUk1BTEtBUiIsImNvdW50cnlDb2RlIjoiVVMiLCJwYXJ0bmVyVGllciI6IiIsImNsaWVudElQIjoiMTgzLjg3LjEyMi43NCIsInJvbGVzIjoiQVRQIFRyYWluaW5nLEJldGFQcm9ncmFtLENTQ01BMS45QkVUQSxDVVNUT01FUixGTEVYU1BFTkQsTVNTUFBBWUdPLE5GUixPcGVyYXRpb25zIGRiIGFjY2VzcyxQT1NUSVQsU2FsZXMgVHJhaW5pbmcsU2l0ZUFkbWluaXN0cmF0b3IsU1BBLFNQT0dDQVMsU1BPR0NBVFAsU1BPR0NDTElFTlQsU1BPR1NNQSxTUE9HVVNFUixTUE9HV0lGSSxTdXBwb3J0VXNlcixTV1RPT2xEZXYsVkFNVXNlcixXT1JLU1BBQ0VCRVRBLFNQT0dTU0MifQ.DU6pBavXPI8lWFATASzi1Sfs5LIJwK-99M0OMncpzw8&serialnumber=2CB8ED6913F1&env=SIM&filetype=CSAFIRMWAREUPDATE';
  buttons: ConfirmButton[] =  [
    { key: 'cancel', name: 'Cancel', isDefault: true },
    { key: 'yes', name: 'Yes' },
  ];
  volumeLicenseModal: boolean = false;
  deleteInstanceConfirm: boolean = false;
  createInstanceConfirm: boolean = false;
  instanceFriendlyName: string = '';
  allInstances: any = [];
  selectedInstance: any = '';
  hideAssignToken: boolean = true;
  hidemaintainKey: boolean = true;
  isCreateInstanceDisabled: boolean = false;
  allCustomers: any = [];
  searchableSelectValue: string = '';
  searchableOptions: SelectOption[] = [];
  country: string = '';
  countryList: SelectOption[] = countryCodes;
  displayCountry: string = '';
  showDropdown: boolean = false;
  showEditCountryIcons: boolean = false;
  tempCountry: string = '';
  code: string = '';
  isoverRide: string = 'NO';
  msspManaged: boolean = false;
  showMSSPMonthlyManagedDialog: boolean = false;
  isMSSPFirewallProduct: boolean = false;
  showSESModal: boolean = false;
  getUserGroups() {
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/getCustomerName')
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      this.allCustomers = resp.productGroup;
      this.searchableOptions = this.allCustomers.map((each: any, index: any) => {
        return {
          id: index.toString(),
          label: each.productGroupName,
          value: each.productGroupName,
          ...each,
        };
      });
      if (this.searchableOptions && this.searchableOptions.length > 0) {
        // @ts-ignore
        const index = this.searchableOptions.findIndex(el => el.productGroupName === this.selectedProduct.groupName);
        this.searchableSelectValue = this.searchableOptions[index].id;
      }
    })
    .catch((errResponse: any) => {
      this.$store.commit('stopLoading');
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: errResponse.msgDesc,
      });
    });
  }

  get hyphenAddedToken() {
    return (originalToken: any) => {
      if (originalToken) {
        const hyphenAddedToken = originalToken.match(/.{1,6}/g);
        return hyphenAddedToken.join('-');
      } return originalToken;
    };
  }

  get asteriskToken() {
    return '*'.repeat(20);
  }

  setAssignTokenOrMaintainKeyShow(str: string) {
    if (str === 'assignToken') this.hideAssignToken = !this.hideAssignToken;
    else if (str === 'maintainKey') this.hidemaintainKey = !this.hidemaintainKey;
  }

  toggleVolumneLicenseModal() {
    this.getInstances(true);
  }

  toogleDeleteInstanceConfirm(item: any) {
    this.selectedInstance = item;
    this.deleteInstanceConfirm = true;
  }

  toggleCreateInstanceConfirm() {
    if (parseInt(this.allInstances.freeNodes, 10) === 0) {
      this.isCreateInstanceDisabled = true;
    } else {
      this.createInstanceConfirm = true;
    }
  }

  goToSerial(serialNo: any) {
    this.volumeLicenseModal = false;
    this.$emit('close-product-detail', serialNo);
  }

  getInstances(callProductGroup: boolean) {
    const template = {
      mode: 'LISTINSTANCES',
      volumeLicenseSerial: this.selectedProduct.serialNumber,
    };
    this.$store.dispatch('MswProductsStoreModule/getInstances', template)
    .then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.volumeLicenseModal = true;
        this.allInstances = resp.content;
        if (parseInt(this.allInstances.freeNodes, 10) > 0) {
          this.isCreateInstanceDisabled = false;
        }
        if (callProductGroup) {
          this.getUserGroups();
        }
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc || 'Something Went Wrong' });
      }
    });
  }
  selectCountry(id: any) {
    this.countryList.forEach((ele : any) => {
      if (id === ele.id) {
        this.code = ele.value;
      }
    });
  }
  onChangeCountry() {
    const request = {
      serialNumber: this.selectedProduct.serialNumber,
      countryCode: this.code !== 'CNA' ? this.code : '',
    };
    this.$store.dispatch('MswProductsStoreModule/updateCountry', request)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:UPDATEGEN7COUNTRYSUCCESS') {
        this.closeCountryChange();
      } else {
        this.closeCountryChange(true);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }
  onClickEditCountry() {
    this.tempCountry = this.displayCountry;
    this.countryList.forEach((ele : any) => {
      if (this.displayCountry === ele.label) {
        this.country = ele.id;
      }
    });
    this.showDropdown = true;
    this.showEditCountryIcons = true;
  }
  closeCountryChange(forceClose: boolean = false) {
    if (forceClose) {
      this.displayCountry = this.tempCountry;
    } else {
      this.countryList.forEach((ele : any) => {
        if (this.code === ele.value) {
          this.displayCountry = ele.label;
        }
      });
    }
    this.showDropdown = false;
    this.showEditCountryIcons = false;
  }

  deleteInstance() {
    const template = {
      mode: 'DELETEINSTANCE',
      volumeLicenseSerial: this.selectedProduct.serialNumber,
      instanceSerialNumber: this.selectedInstance.serNo,
    };
    this.$store.dispatch('MswProductsStoreModule/deleteInstance', template)
    .then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc || 'Success' });
        this.deleteInstanceConfirm = false;
        this.selectedInstance = '';
        this.getInstances(false);
        this.$emit('refresh-main-list');
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc || 'Something Went Wrong' });
      }
    });
  }

  createInstance() {
    if (this.instanceFriendlyName.trim() === '') {
      return this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Please fill in friendly name' });
    }
    if (this.instanceFriendlyName.length > 50) {
      return this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Friendly name can only be 50 characters long' });
    }
    const product = this.searchableOptions.find((each: any) => {
      return each.id === this.searchableSelectValue;
    });
    // @ts-ignore
    const template = {
      mode: 'CREATEINSTANCE',
      volumeLicenseSerial: this.selectedProduct.serialNumber,
      friendlyName: this.instanceFriendlyName,
      // @ts-ignore
      productGroupId: product.productGroupId,
    };
    this.$store.dispatch('MswProductsStoreModule/createInstance', template)
    .then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.getInstances(false);
        this.$emit('refresh-main-list');
        this.createInstanceConfirm = false;
        this.instanceFriendlyName = '';
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc || 'Success' });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc || 'Something Went Wrong' });
      }
    });
  }

  get selectedProduct() {
    this.msspManaged = (this.productDetails.isMSSPManaged ? true : false) || false;
    return this.productDetails;
  }
  @Watch('productDetails',  { deep : true })
  productListChanged() {
    // console.warn('getting');
    // const isCsaFirmwareS3FileAvailable = res[0].content.pDetail[0].isCsaFirmwareS3FileAvailable;
    // switch (isCsaFirmwareS3FileAvailable) {
    //   case 'YES': {
    //     const CsaFirmwareDownloadApiLink = res[0].content.pDetail[0].CsaFirmwareDownloadApiLink;
    //     const CsaFirmwareDownloadLinkText = res[0].content.pDetail[0].CsaFirmwareDownloadLinkText;
    //     console.log('Alice in Chains', CsaFirmwareDownloadApiLink, CsaFirmwareDownloadLinkText);
    //     break;
    //   }
    //   case 'NO': {
    //     const CsaFirmwareDownloadApiLink = res[0].content.pDetail[0].CsaFirmwareDownloadApiLink;
    //     const CsaFirmwareDownloadLinkText = res[0].content.pDetail[0].CsaFirmwareDownloadLinkText;
    //     console.log('Alice in Chains', CsaFirmwareDownloadApiLink, CsaFirmwareDownloadLinkText);
    //     break;
    //   }
    //   default: break;
    // }
    this.isSSEProduct = this.productDetails.pID === '409' ? true : false;
    this.ztToggle = this.productDetails.ztValue === '1' ? true : false;
    if (this.productDetails.FirewallManagementoptiondetails) {
      if (this.productDetails.FirewallManagementoptiondetails.firewallmgnoptions) {
        if (this.productDetails.manageName.toUpperCase()
        .indexOf('BOX') > -1) {
          this.disableFwManagement = true;
        } else {
          this.disableFwManagement = false;
        }
        if (this.productDetails.FirewallManagementoptiondetails.firewallmgnoptions.length > 1) {
          this.showEditOptionPencil = true;
        } else {
          this.showEditOptionPencil = false;
        }
        this.showFirewallMangement = true;
      } else {
        this.showFirewallMangement = false;
      }
    } else {
      this.showFirewallMangement = false;
    }
    if (this.productDetails.isGen7Wireless === 'YES' && this.productDetails.wirelesslocation
    && (this.productDetails.wirelesslocation !== '' && this.productDetails.wirelesslocation !== '  ')
    ) {
      this.countryList.forEach((ele : any) => {
        if (this.productDetails.wirelesslocation === ele.value) {
          this.country = ele.id;
          this.displayCountry = ele.label;
        }
      });
    } else if (this.productDetails.isGen7Wireless === 'YES') {
      this.country = '0';
      this.displayCountry = 'N/A';
    }
    if (this.parentProductTableData.length > 0) {
      if (this.selectedProduct.parentAssociationList[0].productID === '400') {
        // this.loadTableHeader();
      }
    }
    this.closedNetworkValue = this.productDetails.isClosedNetworkEnabled;
    if (this.productDetails.hasOwnProperty('isNSvMgnModeEnable')) {
      this.showNsvToggle = this.productDetails.isNSvMgnModeEnable === 'YES' ? true : false;
      this.showNsvToggleValue = this.productDetails.NSvMgnModeValue === '0' ? false : true;
    }
  }

  get newTableData(): TableEntry[] {
    const tableData = this.parentProductTableData.map((el: any, index: any) => {
      return {
        _key: index + 1,
        ...el,
      };
    });
    return tableData;
  }

  get parentProductTableConfig(): TableColumnConfig[] {
    return [{
      key: 'assocTypeName',
      dataKey: 'assocTypeName',
      sorter: true,
      width: 250,
      title: this.$t('products.parentProductType')
      .toString(),
    },
    {
      key: 'friendlyName',
      dataKey: 'friendlyName',
      sorter: true,
      width: 250,
      title: this.$t('support.FriendlyNm')
      .toString(),
    },
    {
      key: 'serialNumber',
      dataKey: 'serialNumber',
      sorter: true,
      // width: 150,
      title: this.$t('products.serialnumber')
      .toString(),
    },
    {
      key: 'actions',
      dataKey: '',
      title: this.$t('products.actions')
      .toString(),
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
        <div class="last_col_actions">
          <span style="max-width: min-content;" v-tooltip={{ content: 'Click here to remove association', compact: true }}
            onClick={() => { this.removeAssociation(data.entry); }} class= { data.entry.bRemoveAssoc ? '' : 'hidden'}>
            <sw-icon name="trash" size="small"></sw-icon>
          </span>
        </div>) as VNode;
      },
      width: 120,
    }];
  }

  get parentProductTableConfig1(): TableColumnConfig[] {
    return [{
      key: 'cloudassocTypeName',
      dataKey: 'cloudassocTypeName',
      sorter: true,
      width: 150,
      title: 'Type',
    },
    {
      key: 'friendlyName',
      dataKey: 'friendlyName',
      sorter: true,
      width: 150,
      title: this.$t('support.FriendlyNm')
      .toString(),
    },
    {
      key: 'serialNumber',
      dataKey: 'serialNumber',
      sorter: true,
      width: 150,
      title: this.$t('products.serialnumber')
      .toString(),
    },
    {
      key: 'datacenterRegion',
      dataKey: 'datacenterRegion',
      sorter: true,
      width: 150,
      title: this.$t('products.region')
      .toString(),
    },
    {
      key: 'dataCenter',
      dataKey: 'dataCenter',
      sorter: true,
      width: 200,
      title: `${this.selectedProduct.parentAssociationList[0].friendlyName} URL`,
    },
    {
      key: 'serialstatus',
      dataKey: 'serialstatus',
      sorter: true,
      width: 150,
      title: this.$t('products.sync')
      .toString(),
    }];
  }

  get parentProductTableData() {
    if (this.selectedProduct.parentAssociationList && this.selectedProduct.parentAssociationList.length > 0) {
      return this.selectedProduct.parentAssociationList;
    }
    return [];
  }

  @Watch('ttServerText')
  onDropDownChange(value : any) {
    this.ttServerEditedText = '';
    if (value === '0') {
      this.showTtServerTextField = true;
    } else {
      this.showTtServerTextField = false;
    }
  }
  @Watch('friendlyNameEditText')
  checkNameLength(value : any) {
    if (value.trim().length > 50) {
      this.friendlyNameEditText = this.friendlyNameEditText.slice(0, 50);
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Friendly Name cannot be more that 50 characters' });
    }
  }
  removeAssociation(data: any) {
    const request = {
      userName: JSON.parse(this.$store.getters.getUserInfo).user.userId,
      associationTypeID: data.assocTypeID,
      primarySerialNumber: data.serialNumber,
      secondarySerialNumber: this.selectedProduct.serialNumber,
    };
    this.$store.dispatch('MswProductsStoreModule/deleteProductAssociation', request)
     .then((response: any) => {
       this.$store.commit('stopLoading');
       if (response.operationStatus === 'OK') {
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
         this.$emit('updateProductDetail');
       } else {
         this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
       }
     });
  }
  get getAssochint() {
    this.assochint = '';
    if (this.selectedProduct.parentAssociationList && this.selectedProduct.parentAssociationList.length > 0
      && this.selectedProduct.parentAssociationList[0].assocTypeName !== null && this.selectedProduct.parentAssociationList[0].assocTypeName !== '') {
      // tslint:disable-next-line:max-line-length
      this.assochint = this.selectedProduct.parentAssociationList[0].productID === '400' ? '' : `as ${this.selectedProduct.parentAssociationList[0].assocTypeName}`;
    }
    return this.assochint;
  }
  openEprsLink() {
    this.$store.dispatch('navigateTo', 'ui/reports?eprs=true');
  }
  openCATPLink() {
    this.$store.dispatch('navigateTo', `ui/reports?catp=${btoa(this.selectedProduct.capATPURL)}`);
  }
  editFriendlyName() {
    this.friendlyNameEditFlag = true;
    this.friendlyNameEditText = this.selectedProduct.friendlyName;
  }
  editProductGroup() {
    this.productGroupList.length === 0 && this.getProductGroups();
    this.productGroupEditFlag = true;
    this.productGroupEditText = this.selectedProduct.groupName;
  }
  handleLink(truth: boolean, link: string, filetype: any) {
    let env;
    switch (envCongif.env) {
      case 'DEV': {
        env = 'DEV';
        break;
      }
      case 'QA': {
        env = 'QA';
        break;
      }
      case 'SIMULATION': {
        env = 'SIM';
        break;
      }
      case 'PROD': {
        env = 'PROD';
        break;
      }
    }
    if (filetype === '') {
      window.open(link, '_blank');
    }
    const currentUser = localStorage.getItem(currentUserKey);
    const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    if (truth) {
      window.open(`${link}token=${token}&serialnumber=${this.productDetails.serialNumber}&env=${env}&filetype=CSAFIRMWAREUPDATE`, '_blank');
    } else {
      // window.open(`${link}token=${token}&serialnumber=${this.productDetails.serialNumber}&env=${env}&filetype=${filetype}`, '_blank');
      this.replaceLocation('downloads/get-csafirmware-downloads');
    }
  }
  replaceLocation(endpoint: string) {
    const userID = this.$store.getters.getUserId;
    const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const serialNumber = this.productDetails.serialNumber;
    const url = `${endpoint}?username=${userID}&sessionID=${sessionID}&serialNumber=${serialNumber}`;
    ApiServiceWrapper.replaceTiltPipe(url);
  }
  editFwManagement() {
    this.fwManagementOption = [];
    this.selectedProduct.FirewallManagementoptiondetails.firewallmgnoptions.forEach((ele : any, index :any) => {
      if (ele.optionname === this.selectedProduct.manageName) {
        this.fwManageValue = ele.optionname;
        console.warn(index);
      }
      this.fwManagementOption.push({
        id : ele.optionname,
        label : ele.optionname,
        value: ele.optionname,
      });
    });
    this.fwManageEditFlag = true;
  }
  editSwitchManagement() {
    this.switchManagementOption = [];
    this.selectedProduct.switchoptions.forEach((ele : any, index :any) => {
      if (ele.name === this.selectedProduct.switchmanagename) {
        this.switchManageValue = ele.name;
        console.warn(index);
      }
      this.switchManagementOption.push({
        id : ele.name,
        label : ele.displayname,
        value: ele.name,
      });
    });
    this.switchMangeEditFlag = true;
  }
  saveEditedManagementOption() {
    if (this.fwManageValue === this.selectedProduct.manageName) {
      this.fwManageEditFlag = false;
    } else if (this.fwManageValue.toUpperCase()
    .indexOf('CLOUD') > -1 && this.selectedProduct.FirewallManagementoptiondetails.arrListOffSite) {
      this.dcOptions = [];
      this.selectedProduct.FirewallManagementoptiondetails.arrListOffSite.forEach((each: any) => {
        this.dcOptions.push({
          id: each.locationID,
          label: each.locationName,
          value: each.locationName,
        });
      });
      this.showDCFirewall = true;
    } else if (this.fwManageValue.toUpperCase()
    .indexOf('CLOUD') > -1 && this.selectedProduct.FirewallManagementoptiondetails.hasOwnProperty('cloudlist')) {
      this.cloudTenantList = [];
      this.showCloudTenantList = true;
      this.selectedProduct.FirewallManagementoptiondetails.cloudlist.forEach((each : any) => {
        this.cloudTenantList.push({
          id: each.serialnumber,
          label: each.datacenter,
          value: each.serialnumber,
        });
      });
    } else if (this.fwManageValue.toUpperCase()
    .indexOf('CLOUD') > -1) {
      if (this.selectedProduct.manageName.toLowerCase() === 'on-box' && this.selectedProduct.isShowReboot) {
        this.options = {
          status: 'major',
          title: this.$t('products.firewallRebootNotice').toString(),
          buttons: [{
            key: 'cancel',
            name: this.$t('common.cancel').toString(),
          },
          {
            key: 'confirm',
            name: this.$t('common.confirm').toString(),
            isDefault: true,
          }],
          message: (h: CreateElement): VNode => { // tslint:disable-line
            return (
              <div>
                <p><strong>{ this.$t('common.important') }</strong>: {this.selectedProduct.switchtoCloudWarningText1}</p>
              </div>
            ) as VNode;
          },
        };
        confirmService.confirm(this.options)
        .then((key: any) => {
          if (key === 'confirm') {
            this.submitDCFirewall('');
          } else {
          }
        });
      } else {
        this.submitDCFirewall('');
      }
    } else if (this.fwManageValue.toUpperCase()
    .indexOf('PREM') > -1 && this.selectedProduct.FirewallManagementoptiondetails.onpremdetails) {
      this.onpremdetails = this.selectedProduct.FirewallManagementoptiondetails.onpremdetails;
      this.showOnPremDialog = true;
    } else if (this.fwManageValue.toUpperCase()
    .indexOf('BOX') > -1) {
      if (this.selectedProduct.manageName.toLowerCase() === 'cloud') {
        this.options = {
          status: 'major',
          title: 'Warning',
          message: (h: CreateElement): VNode => { // tslint:disable-line
            return (
              <div>
              Changing the management option from Cloud to On-Box causes loss of existing data and removing of this serial number from Cloud Security Center.
              Are you sure you want to continue ?
              </div>
            ) as VNode;
          },
          buttons: this.buttons,
        };
        confirmService.confirm(this.options)
        .then((key: any) => {
          if (key === 'yes') {
            this.submitOnBoxManagement();
          } else {
          }
        });
      } else {
        this.submitOnBoxManagement();
      }
    }
  }
  saveEditedSwitchManagementOption() {
    if (this.switchManageValue === this.selectedProduct.switchmanagename) {
      this.switchMangeEditFlag = false;
    } else {
      const req = {
        serialNumber: this.selectedProduct.serialNumber,
        fromproductgroupid: '',
        Toproductgroupid: '',
        DatacenterId: '',
        policyserver: '',
        gmsserialnumber: '',
        ttserverfqdn: '',
        operation: this.switchManageValue,
        tenantserialnumber: '',
        ztvalue: '',
        isswitch: 'YES',
      };
      this.$store.dispatch('MswProductsStoreModule/firewallManagementOption', req)
     .then((response: any) => {
       if (response.operationStatus === 'OK') {
         this.switchMangeEditFlag = false;
         this.$emit('updateProductDetail');
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
       } else {
         this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
       }
     });
    }
  }
  submitOnBoxManagement() {
    const req = {
      serialNumber : this.selectedProduct.serialNumber,
      fromproductgroupid: this.selectedProduct.productgroupList[0].productGroupID,
      Toproductgroupid: '',
      DatacenterId: '',
      gmsserialnumber: '',
      ttserverfqdn: '',
      operation: '',
      ztValue:this.selectedProduct.ztValue,
      isoverRide: this.isoverRide || 'NO',
      // tslint:disable-next-line:max-line-length
      tenantserialnumber: this.selectedProduct.FirewallManagementoptiondetails.tenantserialnumber ? this.selectedProduct.FirewallManagementoptiondetails.tenantserialnumber : '',
    };
    // req.
    if (this.selectedProduct.manageName.toUpperCase()
    .indexOf('CLOUD') > -1) {
      req.operation = 'CLOUD-ONBOX';
    } else if (this.selectedProduct.manageName.toUpperCase()
    .indexOf('PREM') > -1) {
      req.operation = 'ONPREM-ONBOX';
    }
    console.warn(req);
    this.$store.dispatch('MswProductsStoreModule/firewallManagementOption', req)
     .then((response: any) => {
       this.$store.commit('stopLoading');
       if (this.isoverRide === 'YES') this.isoverRide = 'NO';
       if (response.operationStatus === 'OK') {
         this.showDCFirewall = false;
         this.fwManageEditFlag = false;
         this.$emit('detailsUpdated');
        //  this.$store.commit('MswProductsStoreModule/editProduct', {
        //    property: 'manageName',
        //    with: 'On-Box',
        //  });
        //  this.$emit('detailsUpdated');
         this.$emit('updateProductDetail');
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
       } else {
         if (this.isoverRide === 'YES') this.isoverRide = 'NO';
         if (response.msgCode === 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT') {
           this.secondaryserialnumbertransfer(response, this.submitOnBoxManagement.bind(this), 'Ok');
         } else {
           this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
         }
       }
     });
  }
  submitDCFirewall(request : any, cloudTenant = false) {
    if (request === '' || request) {
      const req = {
        serialNumber : this.selectedProduct.serialNumber,
        fromproductgroupid: this.selectedProduct.productgroupList[0].productGroupID,
        Toproductgroupid: '',
        DatacenterId: cloudTenant ? '' : request.datacenter ? request.datacenter : '',
        gmsserialnumber: '',
        ttserverfqdn: '',
        operation: '',
        tenantserialnumber: request === '' ? this.selectedProduct.FirewallManagementoptiondetails.tenantserialnumber : cloudTenant ? request : '',
        ztValue:this.selectedProduct.ztValue,
        isoverRide: this.isoverRide || 'NO',
      };
      // req.
      if (this.selectedProduct.manageName.toUpperCase()
      .indexOf('BOX') > -1) {
        req.operation = 'ONBOX-CLOUD';
      } else if (this.selectedProduct.manageName.toUpperCase()
      .indexOf('PREM') > -1) {
        req.operation = 'ONPREM-CLOUD';
      }
      this.$store.dispatch('MswProductsStoreModule/firewallManagementOption', req)
       .then((response: any) => {
         this.$store.commit('stopLoading');
         if (this.isoverRide === 'YES') this.isoverRide = 'NO';
         if (response.operationStatus === 'OK') {
           this.showDCFirewall = false;
           this.fwManageEditFlag = false;
           this.$emit('detailsUpdated');
          //  this.$store.commit('MswProductsStoreModule/editProduct', {
          //    property: 'manageName',
          //    with: 'Cloud',
          //  });
          //  this.$emit('detailsUpdated');
           this.$emit('updateProductDetail');
           this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
         } else {
           if (response.msgCode === 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT') {
             this.secondaryserialnumbertransfer(response, this.submitDCFirewall.bind(this, request, cloudTenant), 'Ok');
           } else {
             this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
           }
         }
       });
    } else {
      this.showDCFirewall = false;
    }
  }
  onPremDialogClose(request : any) {
    if (request === '' || request) {
      const req = {
        serialNumber : this.selectedProduct.serialNumber,
        fromproductgroupid: this.selectedProduct.productgroupList[0].productGroupID,
        Toproductgroupid: '',
        DatacenterId: '',
        gmsserialnumber: request.serialnumber,
        ttserverfqdn: request.ttserverfqdn,
        operation: '',
        tenantserialnumber: request === '' ? this.selectedProduct.FirewallManagementoptiondetails.tenantserialnumber : '',
        ztValue:this.selectedProduct.ztValue,
        isoverRide: this.isoverRide || 'NO',
      };
      // req.
      if (this.selectedProduct.manageName.toUpperCase()
      .indexOf('BOX') > -1) {
        req.operation = 'ONBOX-ONPREM';
      } else if (this.selectedProduct.manageName.toUpperCase()
      .indexOf('CLOUD') > -1) {
        req.operation = 'CLOUD-ONPREM';
      }
      console.warn(req);
      this.$store.dispatch('MswProductsStoreModule/firewallManagementOption', req)
       .then((response: any) => {
         if (this.isoverRide === 'YES') this.isoverRide = 'NO';
         this.$store.commit('stopLoading');
         if (response.operationStatus === 'OK') {
           this.showOnPremDialog = false;
           this.fwManageEditFlag = false;
           this.$emit('detailsUpdated');
          //  this.$store.commit('MswProductsStoreModule/editProduct', {
          //    property: 'manageName',
          //    with: 'On-Prem',
          //  });
          //  this.$emit('detailsUpdated');
           this.$emit('updateProductDetail');
           this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
         } else {
           if (response.msgCode === 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT') {
             this.secondaryserialnumbertransfer(response, this.onPremDialogClose.bind(this, request), 'Ok');
           } else {
             this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
           }
         }
       });
    } else {
      this.showOnPremDialog = false;
    }
  }
  editfqdnList() {
    this.ttServerList = [];
    this.selectedProduct.ttfqdnList.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.ttvalue;
      inner['label'] = element.ttname;
      inner['value'] = element.ttname;
      this.ttServerList.push(inner);
    });
    this.ttServerText = this.ttServerList[0].id;
    this.ttfqdnListEditFlag = true;
  }
  saveEditedFriendlyName() {
    if (this.friendlyNameEditText.trim().length > 0) {
      this.friendlyNameEditFlag = false;
      this.$store.commit('MswProductsStoreModule/editProduct', { property: 'friendlyName', with: this.friendlyNameEditText });
      this.$store.dispatch('MswProductsStoreModule/editProductInDB', { serialNumber: this.selectedProduct.serialNumber, newName: this.friendlyNameEditText })
      .then((res: any) => {
        if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
          this.$emit('renamedFriendlyName', { entry : {
            serNo: this.selectedProduct.serialNumber,
            friendlyName: this.friendlyNameEditText,
          }});
        }
        // idb.refreshStore(PRODUCTS_STORE_NAME);
        // this.$emit('detailsUpdated');
        this.$store.commit('stopLoading');
      });
    }
  }
  saveEditedttfqdnListName() {
    if (this.ttServerText === '0' && this.ttServerEditedText === '') {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Please enter ZeroTouch Agent Public IP/FQDN' });
    } else {
      this.ttfqdnListEditFlag = false;
      this.$store
        .dispatch('MswProductsStoreModule/editttServer', {
          policyServerUrl: this.selectedProduct.ztonprempolicyurl,
          ttServerFQDN : this.ttServerEditedText === '' ? this.ttServerText : this.ttServerEditedText,
          serialNumber: this.selectedProduct.serialNumber,
        })
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'OK') {
            this.$emit('detailsUpdated');
            // tslint:disable-next-line:max-line-length
            this.$store.commit('MswProductsStoreModule/editProduct', { property: 'ztonpremttfqdnurl', with: this.ttServerEditedText === '' ? this.ttServerText : this.ttServerEditedText });
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Updated successfully' });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          }
        });
    }
  }
  saveEditedProductGroup(dcidVal? : any) {
    this.productGroupEditFlag = false;
    const newProductGroup = this.productGroupList.filter((each: any) => each.value === this.productGroupEditText)[0].label;
    let req;
    if (dcidVal && dcidVal.datacenter) {
      req = {
        serialNumber: this.selectedProduct.serialNumber,
        productGroupId : this.productGroupEditText,
        bsendMail: true,
        bCSCProceed: true,
        isZTEnable: this.selectedProduct.isZTEnable,
        dcid : dcidVal.datacenter,
      };
    } else {
      req = {
        serialNumber: this.selectedProduct.serialNumber,
        productGroupId : this.productGroupEditText,
        bsendMail: true,
        bCSCProceed: true,
        isZTEnable: this.selectedProduct.isZTEnable,
      };
    }
    this.$store
      .dispatch('MswProductsStoreModule/changeTenantForProduct', req)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:MANAGEPRODUCTSSUCCESS') {
          this.$emit('detailsUpdated');
          this.$store.commit('MswProductsStoreModule/editProduct', { property: 'groupName', with: newProductGroup });
        } else if (res.msgCode === 'MSWAPP:NEEDDC') {
          this.dcOptions = res.arrListOffSite.map((each: any) => {
            return {
              id: each.locationID,
              label: each.locationName,
              value: each.locationName,
            };
          });
          this.showTenantChangeDC = true;
        }
      });
  }
  closeTenantChangeDialog(val : any) {
    this.showTenantChangeDC = false;
    if (val) {
      this.saveEditedProductGroup(val);
    }
  }
  updateZT() {
    this.$store
      .dispatch('MswProductsStoreModule/updateZT', {
        serialNumber: this.selectedProduct.serialNumber,
        ztValue: this.selectedProduct.ztValue === '1' ? '0' : '1',
        dc: this.selectedProduct.userdefaultdc,
        isoverRide: this.isoverRide || 'NO',
      })
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          if (this.isoverRide === 'YES') this.isoverRide = 'NO';
          this.$store.commit('MswProductsStoreModule/editProduct', {
            property: 'manageName',
            with: res.content[0].manageName,
          });
          this.$store.commit('MswProductsStoreModule/editProduct', {
            property: 'ztValue',
            with: this.selectedProduct.ztValue === '1' ? '0' : '1',
          });
          this.$emit('updateProductDetail');
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        } else {
          if (this.isoverRide === 'YES') this.isoverRide = 'NO';
          if (res.msgCode === 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT') {
            this.secondaryserialnumbertransfer(res, this.updateZT.bind(this), 'Ok');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          }
        }
      });
  }
  showProductAssociationDialog(association: any) {
    this.showAssociationProduct = true;
    this.associatedTask = association;
  }

  secondaryserialnumbertransfer(res: any, callerMethod: Function, confirmText: string = 'Save', cancelText: string = 'Cancel') {
    const options: ConfirmOptions = {
      status: 'high',
      title: this.$t('products.productTransferConfirmation')
        .toString(),
      message: res.msgDesc || '',
      buttons: [{
        key: 'save',
        name: confirmText,
        isDefault: true,
      }, {
        key: 'cancel',
        name: cancelText,
        isDefault: false,
      }],
    };
    confirmService.confirm(options)
      .then((value) => {
        if (value === 'save') {
          this.isoverRide = 'YES';
          callerMethod();
        } else {
          this.isoverRide = 'NO';
        }
      });
  }

  // @Watch('selectedProduct')
  // refreshOverlay() {
  //   this.checkForDataCenter();
  // }
  showLicenseSharing() {
    this.showLicenseSharingDialog = true;
  }
  closeLicenseSharingDialog(isRefreshProdList: boolean) {
    if (isRefreshProdList) {
      this.$emit('detailsUpdated');
    }
    this.showLicenseSharingDialog = false;
  }
  checkForDataCenter() {
    const compareWith: string = this.$t('products.updateForCATP')
      .toString();
    this.todoList.forEach((el: any) => {
      if (el.taskListId === '620003' || el.displayText === compareWith) {
        const request = {
          customerTaskId: el.taskListId,
        };
        this.$store
        .dispatch('MswProductsStoreModule/manageCaptureDC', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.content.dataCenter.length > 0) {
            const { serialNumber } = this.selectedProduct;
            this.$store
            .dispatch('MswProductsStoreModule/getProductToDoList', serialNumber)
            .then((resp: any) => {
              this.$store.commit('stopLoading');
              this.$emit('refreshTodoEmpty', resp.content.toDoList);
              return false;
            });
          }
        });
      }
    });
  }

  created() {
    console.warn('FIXED RESIZE LISTENER ERRORS');
    this.productListChanged();
    this.todaysDate = this.todayDate;
    let naPresent: boolean = false;
    this.countryList.some((ele: any) => {
      if (ele.id === '0') naPresent = true;
      else naPresent = false;
    });
    if (!naPresent) {
      this.countryList.push({
        id: '0',
        value: 'CNA',
        label: 'N/A',
      });
    }
  }

  loadTableHeader() {
    // this.parentProductTableConfig1 =
  }

  handleTodo(unit: any) {
    if (unit.redirectUrl !== undefined && unit.redirectUrl !== '') {
      const isIframed = location !== parent.location;
      if (isIframed) {
        const regexContemparary = /.+?(?=ui\/)/; // For Contemparary Mode Redirection
        if (unit.redirectUrl.indexOf('ui/activatehes') > 0) {
          this.$router.push({ path: `/m/feature/hosted-email-security?${unit.redirectUrl.split('?')[1]}` });
        } else if (unit.redirectUrl.indexOf('~/') > -1) {
          this.$store.dispatch('navigateToClassic', unit.redirectUrl.replace('~/', '')); // For Classic Mode Redirection
        } else {
          this.$store.dispatch('navigateTo', unit.redirectUrl.replace(regexContemparary, ''));
        }
      } else {
        if (unit.redirectUrl.indexOf('ui/activatehes') > 0) {
          this.$router.push({ path: `/m/feature/hosted-email-security?${unit.redirectUrl.split('?')[1]}` });
        } else {
          let workspacePath: string = unit.redirectUrl;
          workspacePath = workspacePath.replace('~/muir/ui', '');
          const url: URL = new URL(`${window.location.origin}${workspacePath}`);
          const fullUrl = `/m/feature${url.pathname.toString()}${url.search}`;
          this.$router.push(fullUrl.toString());
        }
      }
    } else {
      this.selectedTodo = unit;
      if (unit.showDataCenter) {
        this.getDCList(unit.taskListId);
      } else if (unit.showPhysicaladdress) {
        this.showPhysicalAddressDialog = true;
      } else if (unit.showNSVRegistration) {
        this.showNSVRegistration = true;
      }else if (unit.showSysLogAnaltyics) {
        this.showSysLogAnaltyicsDialog = true;
      } else if (unit.showScrutinizer) {
        this.showScrutinizerDialog = true;
      } else if (unit.showLmRegisterationcdg || unit.showManageMafeenav || unit.showManagES1 || unit.showTransfers1 || unit.isHESLMRegistration) {
        this.validateAndSubmitTodo({});
      } else if (unit.showManagSesSeed) {
        this.showSESModal = true;
      } else if (unit.showManageCapture) {
        const request = {
          customerTaskId: unit.taskListId,
        };
        this.$store
        .dispatch('MswProductsStoreModule/manageCaptureDC', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:SUCCESS') {
            if (res.content.dataCenter === undefined) {
              this.$store.commit('enqueueMessage', {
                infoType: 'success',
                infoMsg: res.msgDesc,
              });
              this.$emit('updateTodo');
            } else if (res.content.dataCenter !== undefined) {
              this.getDCList(unit.taskListId);
            }
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'error',
              infoMsg: res.msgDesc,
            });
          }
        });
      } else if (unit.showManagEees) {
        const request = {
          customerTaskId: unit.taskListId,
        };
        this.$store
        .dispatch('MswProductsStoreModule/getEmailEncryptionDC', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:SUCCESS') {
            this.emailSecurityDetail = res.content;
            this.showEmailSecurityDialog = true;
          }
        });
      } else if (unit.showSMA8200vRegistration) {
        const request = {
          serialNumber:  this.selectedProduct.serialNumber ?  this.selectedProduct.serialNumber : '',
        };
        this.$store
        .dispatch('MswProductsStoreModule/registerSMASerial', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:SUCCESS') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: res.msgDesc,
            });
            this.$emit('detailsUpdated');
            this.$store.commit('MswProductsStoreModule/mutate', {
              property: 'selectedSerialNumer',
              with: res.content.serialNumber ? res.content.serialNumber : '',
            });
            this.$store.commit('MswProductsStoreModule/setCurrentTab', {
              value: 'licenses',
              updateOperation: 'assign',
              updateMode: 'id',
            });
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'failed',
              infoMsg: res.msgDesc,
            });
          }
        })
        .catch((errResponse: any) => {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg: errResponse.msgDesc,
          });
        });
      }
    }
  }
  getProductGroups() {
    this.$store.dispatch('MswProductsStoreModule/getProductGroupList', { serialNumber: this.selectedProduct.serialNumber })
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.productGroupList = res.arrproductgroup.map((each: any) => {
        return  {
          id: each.groupid,
          label: each.groupname,
          value: each.groupid,
        };
      });
    })
    .catch((errResponse: any) => {
      this.$store.commit('stopLoading');
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: errResponse.msgDesc,
      });
    });
  }
  // function to fetch data center details
  getDCList(customerTaskId: any) {
    this.$store.dispatch('MswProductsStoreModule/getCaptureDatacenter', { customerTaskId })
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (Object.keys(res.content).length === 0 && res.msgCode === 'MSWAPP:SUCCESS') {
        console.warn('Calling Todo');
        this.$emit('updateTodo');
      } else {
        this.dcOptions = res.content.dataCenter.map((each: any) => {
          return {
            id: each.dataCenterName,
            label: each.dataCenterDesc,
            value: each.dataCenterName,
          };
        });
        this.showDataCenterDialog = true;
      }
    });
  }

  validateAndSubmitTodo(request: any) {
    console.warn(request);
    this.showPhysicalAddressDialog = false;
    this.showScrutinizerDialog = false;
    this.showDataCenterDialog = false;
    this.showEmailSecurityDialog = false;
    this.showSysLogAnaltyicsDialog = false;
    this.showNSVRegistration = false;
    if (request) {
      this.$store
        .dispatch('MswProductsStoreModule/completeTodoList', {
          customerTaskId: this.selectedTodo.taskListId,
          taskName: this.selectedTodo.taskHeaderName,
          ...request,
        })
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: res.msgDesc,
            });
            this.$emit('updateTodo');
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'failed',
              infoMsg: res.msgDesc,
            });
          }
        });
    }
  }
  closeProductAssociation(updateProductDetails: boolean) {
    this.showAssociationProduct = false;
    updateProductDetails && this.$emit('updateProductDetail');
  }

  goToHESConsole() {
    const request = {
      tenant: this.productDetails.groupid,
      tileName: 'ISMSWSAFEENABLED',
    };
    this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        const { accessCode } = resp.content;
        const url = `${envCongif.spog_url}/muir/spog/login?code=${accessCode}&mode=tileclick&tile=CLOUD EMAIL&tenantid=${this.productDetails.groupid}`;
        if (envCongif.leftNavMode === 'APP') {
          window.parent.location.href = url;
        } else {
          window.location.href = url;
        }
      })
      .catch((errorRespose: any) => {
        this.$store.commit('stopLoading');
        console.error(errorRespose);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    // let qsparam: string = `mode=tileclick&tile=Cloud Email&tenantid=${this.selectedProduct.groupid}`;
    // qsparam = jsEncrypt.getEncryptObj_msw()
    // .encrypt(qsparam);
    // const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    // // tslint:disable-next-line:max-line-length
    // window.open(`https://${window.location.hostname.toLowerCase()}/api/partnerappsToken?username=${this.$store.getters.getUserId}&appName=SPOG&sessionID=${sessionId}&qsparams=${qsparam}, '_blank'`);
  }

  openMXRecordDialog() {
    this.$store.dispatch('viewCurrentMXRecord', this.selectedProduct.serialNumber)
    .then((resp) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        this.domainName = resp.content.domain;
        this.mxRecords = resp.content.currentMXRecords.split(',');
        this.showMXRecordDialog = true;
      }
    });
  }

  openResetPasswordDialog() {
    this.showUpdateHesPasswordDialog = true;
  }
  onshowUpdateWCMDialog() {
    this.showUpdateWCMDialog = true;
  }
  closeUpdateWCMDialog(val: boolean) {
    this.showUpdateWCMDialog = false;
    if (val) {
      this.$emit('updateProductDetail');
    }
  }
  submitPassword(request: any) {
    this.showUpdateHesPasswordDialog = false;
    if (request) {
      const requestToSubmit = {
        serialNumber: this.selectedProduct.serialNumber,
        userName: this.$store.getters.getUserId,
        password: request.newPassword,
        comments: request.comment,
      };
      this.$store.dispatch('resetPassword', requestToSubmit)
        .then((resp) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
        });
    }
  }
  closeCLoudTenantListDialog(req : any) {
    if (req.datacenter !== '') {
      this.showCloudTenantList = false;
      this.submitDCFirewall(req.datacenter, true);
    } else {
      this.showCloudTenantList = false;
    }
  }
  manageGuid(actionType: string) {
    if (actionType === 'ADDGUID') {
      this.modalValues = {
        headerTitle: 'Add Guid',
        mode: 'edit',
        serialNumber: this.selectedProduct.serialNumber,
        guid: this.selectedProduct.GUID,
      };
    } else if (actionType === 'EDITGUID') {
      this.modalValues = {
        headerTitle: 'Edit Guid',
        mode: 'edit',
        serialNumber: this.selectedProduct.serialNumber,
        guid: this.selectedProduct.GUID,
      };
    } else {
      this.modalValues = {
        headerTitle:'Delete Guid',
        mode:'del',
        serialNumber: this.selectedProduct.serialNumber,
      };
    }
    this.showManageGuidDialog = true;
  }
  closeManageGuidDialog() {
    this.showManageGuidDialog = false;
  }
  closeZtServerDialog(obj : any) {
    this.showZtServerConfig = false;
    if (obj) {
      this.$emit('updateProductDetail');
    }
  }
  openZtServerConfigPopUp() {
    if (this.selectedProduct.NSMZTserverurl === null || this.selectedProduct.NSMZTserverurl === ''
    || this.selectedProduct.NSMZTserverurlfqdn === null || this.selectedProduct.NSMZTserverurlfqdn === '') {
      this.ztServerObj['ttserverurl'] = '';
      this.ztServerObj['ttserverfqdn'] = '';
      this.ztServerObj['serialNumber'] = this.selectedProduct.serialNumber;
    } else {
      this.ztServerObj['ttserverurl'] = this.selectedProduct.NSMZTserverurl;
      this.ztServerObj['ttserverfqdn'] = this.selectedProduct.NSMZTserverurlfqdn;
      this.ztServerObj['serialNumber'] = this.selectedProduct.serialNumber;
    }
    console.warn(this.ztServerObj);
    this.showZtServerConfig = true;
  }

  get managedByTooltipValue(): TooltipDirValues {
    let content = '';
    if (this.selectedProduct.manageName === 'On-Box' || this.selectedProduct.manageName === 'Cloud') {
      content = String(this.$t('products.managedByInfo'));
    }
    return {
      content,
      placement: 'right',
      compact: true,
    };
  }
  handleEnableClosedNetwork() {
    if ((this.selectedProduct.pID === '7636' || this.selectedProduct.pID === '7637')
      && this.selectedProduct.GUID !== undefined && this.selectedProduct.GUID === '') {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('products.guidError') });
      if (this.closedNetworkValue) {
        this.closedNetworkValue = false;
      }
    } else {
      if (this.closedNetworkValue) {
        const request = {
          strSerialNumber: this.selectedProduct.serialNumber,
        };
        this.$store.dispatch('MswProductsStoreModule/enableCloseNetwork', request)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              this.$emit('updateProductDetail');
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            }
          })
          .catch((errMsg: any) => {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errMsg.msgDesc });
          });
      }
    }
  }
  showClosedNetworkDialog() {
    this.showClosedNetwork = true;
  }
  closeClosednetwork(value: boolean) {
    if (value) {
      this.$emit('updateProductDetail');
    }
    this.showClosedNetwork = false;
  }
  addAssignToken() {
    const request = {
      serialNumber: this.selectedProduct.serialNumber,
    };
    this.$store.dispatch('MswProductsStoreModule/assignToken', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc ? res.msgDesc : 'Assign token generated successfully.' });
          this.$emit('updateProductDetail');
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc ? res.msgDesc : 'Assign token generation failed.' });
        }
      })
      .catch((error: any) => {
        console.warn(error);
        this.$store.commit('stopLoading');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: error.msgDesc ? error.msgDesc : 'Assign token generation failed.' });
      });
  }
  navigateToFirmwareTab() {
    this.$emit('navigateToFirmwareTab');
  }
  get assignTokenTooltipValue(): TooltipDirValues {
    const content = String(this.$t('products.assigntokentooltip'));
    return {
      content,
      placement: 'top',
      compact: true,
    };
  }
  showNsvToggleValueChange() {
    if (this.showNsvToggleValue) {
      this.options = {
        status: 'normal',
        title: 'Confirmation',
        message: (h: CreateElement): VNode => { // tslint:disable-line
          return (
            <div>
            Firewalls running SonicOSX 7.0.1 and above, have an option to switch firewall mode between Global and Policy Mode.
            By enabling this setting, you will have an option on your Firewall UI to select between Policy Mode and Global Mode.
            </div>
          ) as VNode;
        },
        buttons: this.buttons,
      };
      confirmService.confirm(this.options)
      .then((key: any) => {
        if (key === 'yes') {
          this.callApiForFirewallModeSwitch();
        } else {
          this.showNsvToggleValue = false;
        }
      });
    } else {
      this.callApiForFirewallModeSwitch();
    }
  }
  callApiForFirewallModeSwitch() {
    const req = {
      serialNumber: this.selectedProduct.serialNumber,
      fromproductgroupid: this.selectedProduct.groupid,
      Toproductgroupid: '',
      DatacenterId: '',
      policyserver: '',
      gmsserialnumber: '',
      ttserverfqdn: '',
      operation: this.switchManageValue,
      tenantserialnumber: '',
      ztvalue: this.showNsvToggleValue ? 1 : 0,
      isswitch: '',
      isnsvmgn: 'YES',
    };
    this.$store.dispatch('MswProductsStoreModule/firewallManagementOption', req)
     .then((response: any) => {
       if (response.operationStatus === 'OK') {
         this.$store.commit('stopLoading');
        //  this.$emit('updateProductDetail');
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
       } else {
         this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
       }
     });
  }

  toggleReveal() {
    this.reveal = !this.reveal;
  }

  copyToClipBoard(url: any) {
    window.navigator.clipboard.writeText(url);
    this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Copied to clipboard!' });
  }

  handleEnroll(value: boolean) {
    if (value) {
      this.showMSSPMonthlyManagedDialog = true;
      // confirmService.confirm({
      //   status: 'major',
      //   title: 'MSSP monthly',
      //   message:'By Managing this device from MSSP, any existing active subscriptions done outside of MSSP Monthly would be lost. Are you sure you want to do this ?',
      //   buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
      // })
      // .then((isConfirmed : any) => {
      //   if (isConfirmed === 'ok') {
      //     this.handleEnrollDerollApi(value);
      //   } else {
      //     this.msspManaged = !this.msspManaged;
      //   }
      // });
    } else {
      confirmService.confirm({
        status: 'major',
        title: 'MSSP monthly',
        message:'Moving out of MSSP Monthly program would end the subscription on the services that were managed by MSSP on this device. Are you sure you want to do this?',
        buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
      })
      .then((isConfirmed : any) => {
        if (isConfirmed === 'ok') {
          this.handleEnrollDerollApi(value);
        } else {
          this.msspManaged = !this.msspManaged;
        }
      });
    }
  }

  closeMSSPMonthlyManaged(val: any) {
    this.showMSSPMonthlyManagedDialog = false;
    if (val === true) {
      this.$emit('detailsUpdated');
      this.$emit('updateProductDetails');
    } else {
      this.msspManaged = !this.msspManaged;
    }
  }

  handleEnrollDerollApi(value: boolean) {
    const enrollDerollMssp: any = {
      serialNumber: this.selectedProduct.serialNumber,
      Mode: value ? 'ENROLL' : 'DEROLL',
    };
    this.$store.dispatch('MswProductsStoreModule/enrollDerollMssp', enrollDerollMssp)
     .then((response: any) => {
       this.$store.commit('stopLoading');
       if (response.operationStatus === 'OK') {
         this.$emit('detailsUpdated');
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
         this.$emit('updateProductDetail');
       } else {
         this.msspManaged = !this.msspManaged;
         this.$emit('detailsUpdated');
         this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
       }
     })
     .catch(() => {
       this.$store.commit('stopLoading');
     });
  }
}
